export default __webpack_public_path__ + "static/media/Visual_joil_16.18622e34.jpg";